
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M650,0H150A150,150,0,0,0,0,150V650A150,150,0,0,0,150,800H500L800,500V150A150,150,0,0,0,650,0Zm50,400c-165.69,0-300,134.31-300,300v70H150A120,120,0,0,1,30,650V150A120,120,0,0,1,150,30H650A120,120,0,0,1,770,150V400Z"}}),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M205.91,272.87a46,46,0,1,1,46,46.05A46,46,0,0,1,205.91,272.87Z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M590,471.22c6.24,7.49,5.23,28.61-2.25,34.84l0,0c-69,57.68-133.7,77.08-189.44,77.08a282.16,282.16,0,0,1-187.5-78.49c-6.72-7.06-6.44-28.24.62-35s28.24-6.44,35,.62c6,6.17,127.28,150.28,308.61-1.41,7.43-6.29,28.56-5.37,34.86,2.07Z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M501.92,272.91A46.09,46.09,0,1,1,548,319,46.08,46.08,0,0,1,501.92,272.91Z"}})])])])
          )
        }
      }
    